import { type FunctionComponent } from 'react';
import { useProjectCreationDrawer } from '../../../../hooks/project-creation-drawer/project-creation-drawer.hooks';
import { StyledButton } from '../../../buttons';
import { LoadableCreateNewProjectDrawer } from '../../create-new-project-drawer/loadable-create-new-project-drawer.component';

export const GetStartedButton: FunctionComponent<{ buttonStyle?: 'PRIMARY' | 'SECONDARY' }> = ({ buttonStyle = 'PRIMARY' }) => {
	const { isNewProjectDrawerOpen, openCreateProjectDrawer, closeCreateProjectDrawer, notifySuccessOnCreation } =
		useProjectCreationDrawer('projects-about-page');

	return (
		<>
			<StyledButton ariaLabel="create project" buttonStyle={buttonStyle} onClick={openCreateProjectDrawer}>
				Start My Project
			</StyledButton>
			{isNewProjectDrawerOpen && (
				<LoadableCreateNewProjectDrawer
					trackingPageName="projects-about-page"
					projectCreated={notifySuccessOnCreation}
					closeDrawer={closeCreateProjectDrawer}
				/>
			)}
		</>
	);
};
